// extracted by mini-css-extract-plugin
export default {"main":"LinkItem_main__kJ1lz","header":"LinkItem_header__dWMg+","dragger":"LinkItem_dragger__qcAsH","remove":"LinkItem_remove__TYT6H"};